import { observer } from "mobx-react-lite";
import {AssignDialogProps} from "../../../../entity/props/project/assign-dialog-props";
import {useService} from "../../../../infrastructure/service/service";
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle, Divider, FormControl, FormHelperText,
    IconButton,
    InputLabel,
    MenuItem,
    Select, SelectChangeEvent
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {Form, Formik, FormikProps} from "formik";
import Grid from "@mui/material/Grid2";
import {AssignDto} from "../../../../entity/dto/assign-dto";
import Box from "@mui/material/Box";
import {DropdownOption} from "../../../../entity/core/dropdown-option";

import '../../../../assets/css/style.css';

const AssignDialog = (props: AssignDialogProps): JSX.Element => {
    const {projectService} = useService();

    const handleValidate = (values: AssignDto): Record<string, string> => {
        const errors: Record<string, string> = {};

        if (!values.assignedToUserID)
            errors.assignedToUserID = 'Abstractor is required.';

        if (!values.assignedToReviewerUserID)
            errors.assignedToReviewerUserID = 'Reviewer is required.';

        return errors;
    }

    return (
        <Dialog open={props.open}>
            <DialogTitle className={'zitles-dialog-title'}>
                <span>Title Order Assignee</span>
                <IconButton id={'btn-assign-user-close'} onClick={(): void => props.setOpen(false)}>
                    <CloseIcon className={'dialog-icon'}/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers className={'zitles-dialog-content small'}>
                <Formik
                    initialValues={projectService.getAssignDto(props.parcelEntry)}
                    validate={handleValidate}
                    onSubmit={props.handleSubmit}>
                    {({values, errors, touched, handleChange, handleBlur, handleSubmit}: FormikProps<AssignDto>): JSX.Element => (
                        <Form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <FormControl required fullWidth error={touched.assignedToUserID && Boolean(errors.assignedToUserID)}>
                                        <InputLabel>Abstractor</InputLabel>
                                        <Select
                                            id={'input-assigned-abstractor'}
                                            name='assignedToUserID'
                                            value={values.assignedToUserID}
                                            label='Abstractor'
                                            onBlur={handleBlur}
                                            onChange={(event: SelectChangeEvent) => handleChange({target: {name: event.target.name, value: event.target.value}})}>
                                            {
                                                props.options.map((option: DropdownOption): JSX.Element => <MenuItem key={option.key} value={option.value}>{option.text}</MenuItem>)
                                            }
                                        </Select>
                                        <FormHelperText>{touched.assignedToUserID && errors.assignedToUserID}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid size={12}>
                                    <FormControl required fullWidth error={touched.assignedToReviewerUserID && Boolean(errors.assignedToReviewerUserID)}>
                                        <InputLabel>Title Reviewer</InputLabel>
                                        <Select
                                            id={'input-assigned-reviewer'}
                                            name='assignedToReviewerUserID'
                                            value={values.assignedToReviewerUserID}
                                            label='Title Reviewer'
                                            onBlur={handleBlur}
                                            onChange={(event: SelectChangeEvent) => handleChange({target: {name: event.target.name, value: event.target.value}})}>
                                            {
                                                props.options.map((option: DropdownOption): JSX.Element => <MenuItem key={option.key} value={option.value}>{option.text}</MenuItem>)
                                            }
                                        </Select>
                                        <FormHelperText>{touched.assignedToReviewerUserID && errors.assignedToReviewerUserID}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Divider sx={{ my: 2, mx: -3 }} />
                            <Box className={'action-btn-container'}>
                                <Button
                                    id={'btn-assign-user-cancel'}
                                    disableTouchRipple
                                    onClick={(): void => props.setOpen(false)}
                                    className={'zitles-button cancel'}>
                                    Cancel
                                </Button>
                                <Button
                                    id={'btn-assign-user-submit'}
                                    type='submit'
                                    className={`zitles-button submit`}>
                                    Submit
                                </Button>
                            </Box>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
}

export default observer(AssignDialog);
